import { useMemo } from 'react';
import { usePanelContext } from 'components/profile-panel/PanelContext';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const ProfileColorDisplay = () => {
    const { settings } = useCurrentAccount();

    const { placeholderColor } = usePanelContext();

    const currentColor = useMemo(() => {
        return settings.find(setting => setting.code === 109)?.value;
    }, [settings]);

    if (!(placeholderColor || currentColor)) {
        return null;
    }

    return (
        <div
            className="absolute left-0 top-0 h-full w-2 rounded-l-xl border border-r-0 border-gray-200"
            style={{
                backgroundColor: placeholderColor ?? currentColor,
            }}
        />
    );
};

export { ProfileColorDisplay };
